import React, { useState } from 'react';

const Contact: React.FC = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // در اینجا درخواست ارسال به API
    setSent(true);
  };

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>تماس با ما</h1>
        </div>
      </div>
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h3>اطلاعات تماس</h3>
              <p><i className="fas fa-phone"></i> 09335754820</p>
              <p><i className="fas fa-envelope"></i> info@greenbeltiran.com</p>
              <p><i className="fas fa-map-marker-alt"></i> اصفهان، مبارکه، دیزیچه، خیابان امام خمینی، باغ ملاباشی</p>
            </div>
            <div className="contact-form">
              <h3>ارسال پیام</h3>
              {sent ? (
                <div className="alert alert-success">پیام شما با موفقیت ارسال شد.</div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>نام</label>
                    <input type="text" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label>ایمیل</label>
                    <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
                  </div>
                  <div className="form-group">
                    <label>پیام</label>
                    <textarea rows={5} value={form.message} onChange={e => setForm({...form, message: e.target.value})} required />
                  </div>
                  <button type="submit" className="btn btn-primary">ارسال</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;